import { render } from "./OutlineRoundedButtons.vue?vue&type=template&id=0ed6ee9e&ts=true"
import script from "./OutlineRoundedButtons.vue?vue&type=script&lang=ts"
export * from "./OutlineRoundedButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__